export const FormFooter = () => (
  <div className="flex items-center justify-center pb-10 pt-6">
    <img src="/icons/reellogo-new.svg" className="h-[60px] min-w-[180px]" alt="REEL Logo" />
  </div>
);
